import { render, staticRenderFns } from "./manageParameter.vue?vue&type=template&id=1618f588"
import script from "./manageParameter.vue?vue&type=script&lang=js"
export * from "./manageParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports